import {DocumentNode, gql} from "@apollo/client";

export const CREATE_PAYMENT_MUTATION: DocumentNode = gql(`
    mutation CreatePayment($dto: CreatePaymentDto!) {
        createPayment(createPaymentDto: $dto) {
            ...PaymentInfo
        }
    }
`);
